import call from "./call";
import {
  Certification,
  QaTemplate,
  SingleCertificationResponse,
} from "../Models/certification";

export const getCertCategories = async (): Promise<Certification[]> => {
  const { data } = await call.get<Certification[]>("/v1/cert_category/", {
    snack: {
      error: "certifications.fetchCategoriesError",
    },
  });
  return data;
};

export const getSingleCertCategory = async (
  id: number
): Promise<SingleCertificationResponse> => {
  const { data } = await call.get<SingleCertificationResponse>(
    `/v1/cert_category/${id}/`
  );
  return data;
};

export const createCertCategory = async (
  newCategory: Omit<Certification, "id">
): Promise<Certification> => {
  const { data } = await call.post<Certification>(
    "/v1/cert_category/",
    newCategory,
    {
      snack: {
        error: "certifications.createError",
        success: "certifications.createSuccess",
      },
    }
  );
  return data;
};

export const editCertCategory = async (
  id: number,
  updatedCategory: Omit<Certification, "id">
): Promise<Certification> => {
  const { data } = await call.put<Certification>(
    `/v1/cert_category/${id}/`,
    updatedCategory,
    {
      snack: {
        error: "certifications.updateError",
        success: "certifications.updateSuccess",
      },
    }
  );
  return data;
};

export const deleteCertCategory = async (id: number): Promise<void> => {
  await call.delete(`/v1/cert_category/${id}/`, {
    snack: {
      error: "certifications.deleteError",
      success: "certifications.deleteSuccess",
    },
  });
};

export const getUserCategories = async (): Promise<Certification[]> => {
  const { data } = await call.get<Certification[]>("/v1/user/certifications/", {
    snack: {
      error: "certifications.fetchUserCategoriesError",
    },
  });
  return data;
};

export const getQaTemplates = async (): Promise<QaTemplate[]> => {
  const { data } = await call.get<QaTemplate[]>("/v1/cert_category/templates/");
  return Array.isArray(data) ? data : [];
};
